import { BCMSStateManagerCRUD, DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import update from "immutability-helper";
import React, { useCallback } from 'react';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from 'react-dnd-html5-backend';
import { LeftColumnContainer, PageContentView, PageLayoutContainer, WidgetContainer, WidgetView } from 'components/shared';
import { PrimaryButton, SecondaryButton } from "components/ui";
import { SVGAsset } from "res";
import AccountTileView from "../AccountTileView";

/**
 * @function ReorderAccountsContent
 * @return {React.Component}
 * @exported true
 * @description The component that shows the content of the reorder accounts page
 */
export default function ReorderAccountsContent(props) {
    const { data, ui, setState, onCancel, onReset } = useStateManager();
    // React-dnd documentation: https://react-dnd.github.io/react-dnd/docs/overview
    // Immutability-helper documentation: https://www.npmjs.com/package/immutability-helper

    // Update function called when an item is being moved, updates the accounts
    // array to the updated list order
    const onMoveItem = useCallback((dragIndex, hoverIndex) => {
        BCMSStateManagerCRUD.init({ data, ui })
            .update(["data", "accounts"], update(
                data.accounts,
                {
                    $splice: [ // Updates the order of the array based on the dragIndex and hoverIndex
                        [dragIndex, 1],
                        [hoverIndex, 0, data.accounts[dragIndex]]
                    ]
                }
            ))
            .submit(setState);
    }, []);
    const onRenderItem = useCallback((item, index) => {
        return <AccountTileView
            key={`Account_${item.id}`}
            account={item}
            dataPoint={"Account_Tile_View"}
            // Requuired for the drag and drop
            index={index}
            id={item.id}
            onMoveItem={onMoveItem} />
    }, []);

    const accountItems = data.accounts.map((item, index) => onRenderItem(item, index), []);

    return (
        <PageContentView>
            <>
                <LeftColumnContainer>
                    <WidgetContainer>
                        <WidgetView text="Reorder Accounts" className="reorder-accounts-widget">
                            <p className="top-text">
                                <span className="top-text-1">Please use the left icon </span>
                                <SVGAsset id="DragDropIcon" className="drag-drop-icon set-width inline-text-icon left-icon" />
                                <span className="top-text-2">to drag and drop accounts and change their order within their account group. You can come back and change this at any time. </span>
                            </p>

                            {/* Account Rows */}
                            <div className="account-tile-container">
                                <DndProvider backend={HTML5Backend}>
                                    {accountItems}
                                </DndProvider>
                            </div>

                            <div className="links-container flex-container flex-horizontal align-center">
                                <a className="reset-link set-width clickable" onClick={onReset}>Reset</a>
                            </div>

                            <div className="page-button-container flex-container flex-horizontal">
                                <SecondaryButton text="Cancel" dataPoint="Cancel" onClick={onCancel} />
                                <DisabledPrompt>
                                    <PrimaryButton text="Save" dataPoint="Save" />
                                </DisabledPrompt>
                            </div>
                        </WidgetView>
                    </WidgetContainer>
                </LeftColumnContainer>
            </>
        </PageContentView>
    );
}

